export class PengajuanPelatihan {
  id: number;
  uuid: string;
  user_id: number;
  sub_menu_jenis_pelatihan_id: number;
  jenis_pelatihan_id: number;
  path_thumbnail: string;
  judul_pelatihan: string;
  jenis_penilaian_id: number;
  waktu_buka_pendaftaran: string;
  waktu_tutup_pendaftaran: string;
  waktu_mulai: string;
  waktu_selesai: string;
  penyelenggara: string;
  informasi_umum: string;
  persyaratan: string;
  angkatan: string;
  kompetensi_teknis: string;
  is_ppkb: number;
  materi_inti: string;
  is_for_guru_madrasah: number;
  status_pengajuan: string;
  alasan: string;
  created_at: string;
  updated_at: string;
  jumlahData: number;
  modulPelatihan: ModulPelatihan[];
  jp: string;
  link_evaluasi: string;
  logo_penyelenggara: string;

  constructor(
    id: number,
    uuid: string,
    user_id: number,
    sub_menu_jenis_pelatihan_id: number,
    jenis_pelatihan_id: number,
    path_thumbnail: string,
    judul_pelatihan: string,
    jenis_penilaian_id: number,
    waktu_buka_pendaftaran: string,
    waktu_tutup_pendaftaran: string,
    waktu_mulai: string,
    waktu_selesai: string,
    penyelenggara: string,
    informasi_umum: string,
    persyaratan: string,
    angkatan: string,
    kompetensi_teknis: string,
    is_ppkb: number,
    materi_inti: string,
    is_for_guru_madrasah: number,
    status_pengajuan: string,
    alasan: string,
    created_at: string,
    updated_at: string,
    jumlahData: number,
    modulPelatihan: ModulPelatihan[],
    jp: string,
    link_evaluasi: string,
    logo_penyelenggara: string
  ) {
    this.id = id;
    this.uuid = uuid;
    this.user_id = user_id;
    this.sub_menu_jenis_pelatihan_id = sub_menu_jenis_pelatihan_id;
    this.jenis_pelatihan_id = jenis_pelatihan_id;
    this.path_thumbnail = path_thumbnail;
    this.judul_pelatihan = judul_pelatihan;
    this.jenis_penilaian_id = jenis_penilaian_id;
    this.waktu_buka_pendaftaran = waktu_buka_pendaftaran;
    this.waktu_tutup_pendaftaran = waktu_tutup_pendaftaran;
    this.waktu_mulai = waktu_mulai;
    this.waktu_selesai = waktu_selesai;
    this.penyelenggara = penyelenggara;
    this.informasi_umum = informasi_umum;
    this.persyaratan = persyaratan;
    this.angkatan = angkatan;
    this.kompetensi_teknis = kompetensi_teknis;
    this.is_ppkb = is_ppkb;
    this.materi_inti = materi_inti;
    this.is_for_guru_madrasah = is_for_guru_madrasah;
    this.status_pengajuan = status_pengajuan;
    this.alasan = alasan;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.jumlahData = jumlahData;
    this.modulPelatihan = modulPelatihan;
    this.jp = jp;
    this.link_evaluasi = link_evaluasi;
    this.logo_penyelenggara = logo_penyelenggara;
  }
}

export class ModulPelatihan {
  id: number;
  pelatihan_id: number;
  judul_modul: string;
  sub_modul: SubModulPelatihan[];
  created_at: string;
  updated_at: string;
  status_pembelajaran: string;

  constructor(
    id: number,
    pelatihan_id: number,
    judul_modul: string,
    sub_modul: SubModulPelatihan[],
    created_at: string,
    updated_at: string,
    status_pembelajaran: string
  ) {
    this.id = id;
    this.pelatihan_id = pelatihan_id;
    this.judul_modul = judul_modul;
    this.sub_modul = sub_modul;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.status_pembelajaran = status_pembelajaran;
  }
}

export class SubModulPelatihan {
  id: number;
  modul_pelatihan_id: number;
  paket_soal_id: number;
  materi_id: number;
  judul: string;
  jenis_ujian: string;
  jenis_sub_modul: string;
  passing_grade: string;
  durasi_latihan: string;
  m_final_project: any;
  m_materi: any;
  m_latihan: any;
  m_paket_soal: any;
  status_pembelajaran: string;
  ada_latihan: number;
  created_at: string;
  updated_at: string;
  waktu_pengumpulan_final_project: string;
  limit_soal: number;
  has_completed_video: boolean;
  t_sub_modul_pelatihan_id: number;

  constructor(
    id: number,
    modul_pelatihan_id: number,
    paket_soal_id: number,
    materi_id: number,
    judul: string,
    jenis_ujian: string,
    jenis_sub_modul: string,
    passing_grade: string,
    durasi_latihan: string,
    m_final_project: any,
    m_materi: any,
    m_latihan: any,
    m_paket_soal: any,
    status_pembelajaran: string,
    ada_latihan: number,
    created_at: string,
    updated_at: string,
    waktu_pengumpulan_final_project: string,
    limit_soal: number,
    has_completed_video: boolean,
    t_sub_modul_pelatihan_id: number
  ) {
    this.id = id;
    this.modul_pelatihan_id = modul_pelatihan_id;
    this.paket_soal_id = paket_soal_id;
    this.materi_id = materi_id;
    this.judul = judul;
    this.jenis_ujian = jenis_ujian;
    this.jenis_sub_modul = jenis_sub_modul;
    this.passing_grade = passing_grade;
    this.durasi_latihan = durasi_latihan;
    this.m_final_project = m_final_project;
    this.m_materi = m_materi;
    this.m_latihan = m_latihan;
    this.m_paket_soal = m_paket_soal;
    this.status_pembelajaran = status_pembelajaran;
    this.ada_latihan = ada_latihan;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.waktu_pengumpulan_final_project = waktu_pengumpulan_final_project;
    this.limit_soal = limit_soal;
    this.has_completed_video = has_completed_video;
    this.t_sub_modul_pelatihan_id = t_sub_modul_pelatihan_id;
  }
}
